// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__HOIAh","navSocials":"styles_navSocials__CVg5C","icon":"styles_icon__QbU4S","copyBoard":"styles_copyBoard__gSWUF"};